const FEATURES = [
  {
    icon: 'ri-image-edit-line',
    color: 'bg-primary-500',
    title: '省流画质',
    desc: '智能切换更省流量的画质档位，让每一屏画面都经过优化，减少大图加载带来的流量消耗，追更不心疼。',
  },
  {
    icon: 'ri-stack-line',
    color: 'bg-secondary-500',
    title: '压缩图模式',
    desc: '开启后自动压缩漫画图片体积，画面细节几乎无损，单章下载体积却大幅下降，加载更快更省流量。',
  },
  {
    icon: 'ri-bar-chart-box-line',
    color: 'bg-accent-500',
    title: '流量监控',
    desc: '实时统计每一部漫画、每一话的流量消耗，用多少心里有数，还支持按天查看你的省流账单。',
  },
  {
    icon: 'ri-wifi-line',
    color: 'bg-primary-500',
    title: '仅WiFi下载',
    desc: '下载漫画前自动校验网络，只在 WiFi 环境下批量缓存，彻底避免流量被悄悄刷走。',
  },
  {
    icon: 'ri-speed-line',
    color: 'bg-secondary-500',
    title: '低流量浏览',
    desc: '低流量模式下优先加载文字与分镜，滑动时按需加载，边走边看漫画也能稳住流量消耗。',
  },
  {
    icon: 'ri-battery-saver-line',
    color: 'bg-accent-500',
    title: '数据节省',
    desc: '一键开启全局数据节省，从图片、缓存到后台同步统一管理，让你的流量花在刀刃上。',
  },
];

export default function Features() {
  return (
    <section id="features" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto mb-10 max-w-2xl text-center md:mb-14">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-sparkling-2-line"></i>
            省流六大能力
          </span>
          <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">
            六大省流功能，看得安心用得放心
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            从画质、图片、下载到流量统计，漫画人极速版为低流量用户准备了完整的数据节省方案，
            每一口流量都花得明明白白。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {FEATURES.map((item) => (
            <article
              key={item.title}
              className="group rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-200 hover:bg-background-50 md:p-6"
            >
              <span
                className={`flex h-11 w-11 items-center justify-center rounded-md text-background-50 md:h-12 md:w-12 ${item.color}`}
              >
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-bold text-foreground-950 md:text-lg">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}